import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export type ThemeEnum = 'default' | 'dark' | 'compact';

@Injectable({ providedIn: 'root' })
export class ThemeService {
	private zorroLinkId = 'zorro-theme';
	private layoutLinkId = 'layout-theme';
	private theme: ThemeEnum = 'default';
	public theme$ = new ReplaySubject<ThemeEnum>(1);

	init() {
		this.theme = (localStorage.getItem("theme") ?? 'default') as ThemeEnum;
		this.setTheme(this.theme);
	}
	getTheme(): ThemeEnum{
		return this.theme;
	}
	setTheme(theme: ThemeEnum) {
		this.theme = theme;
		this.theme$.next(theme);
		localStorage.setItem("theme", theme);

		const zorroHref = {
			default: 'zorro-default.css',
			dark: 'zorro-dark.css',
			compact: 'zorro-compact.css'
		}[theme];

		const layoutHref = {
			default: '/assets/themes/custom-theme-default.css',
			dark: '/assets/themes/custom-theme-dark.css',
			compact: '/assets/themes/custom-theme-compact.css'
		}[theme];

		this.setLink(this.zorroLinkId, zorroHref);
		this.setLink(this.layoutLinkId, layoutHref);
	}

	private setLink(id: string, href: string) {
		let linkEl = document.getElementById(id) as HTMLLinkElement;
		if (!linkEl) {
			linkEl = document.createElement('link');
			linkEl.id = id;
			linkEl.rel = 'stylesheet';
			document.head.appendChild(linkEl);
		}
		linkEl.href = href;
	}
}
